export default "__VITE_ASSET__Pqzqu83A__"